const baseUrl = window.location.hostname.indexOf('espn-consumption-tool-np') !== -1 ? "https://espn-consumption-tool-np.api.aws-ma-us-west-2.nlsn.media/" : "https://api.espnconsumption.nielsen.com/"
export const get_content_types = baseUrl + "api/get_content_types";
export const get_networks = baseUrl + "api/get_networks";
export const get_years = baseUrl + "api/get_years";
export const get_weeks = baseUrl + "api/get_weeks_by_year/";
export const get_preview = baseUrl + "api/get_preview";
export const get_period = baseUrl + "api/get_period";
export const get_tv_schedule = baseUrl + "api/get_tv_schedule";
export const get_content_type_chars = baseUrl + "api/get_content_type_chars";
export const get_mediums = baseUrl + "api/get_mediums";
export const get_metrics = baseUrl + "api/get_metrics";
export const get_reports = baseUrl + "api/get_reports";
export const submit_report = baseUrl + "api/submit_simulation_report";
export const submit_optimization_report = baseUrl + "api/submit_optimization_report";
export const fetch_optimization_report = baseUrl + "api/fetch_optimization_report";
export const get_contenttype_mediums = baseUrl + "api/get_contenttype_mediums";
export const export_simulation_report = baseUrl + "api/export_simulation_report"

